export const DASHBOARD_OFICINA = () => '/dashboard-oficina';
